import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation
} from '@angular/core';

import { isNullOrUndefined } from '@app/util/util';
import {
  DataPickerChangedEvent, DataPickerModel
} from '@design-system/components/organisms/data-picker/entities/data-picker.types';

@Component({
  selector: 'app-air-timepicker',
  templateUrl: './air-timepicker.component.html',
  styleUrls: ['./air-timepicker.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AirTimepickerComponent implements OnInit {

  @Input() initValue: string;
  @Input() initialPlaceHolder: string;
  @Input() minTime = 0;
  @Input() maxTime = 23;
  @Input() value: string;

  @Output() timeSelection: EventEmitter<string> = new EventEmitter<string>();

  public showSwipeUp = false;
  public timeValue = '';

  public dataPickerModel: DataPickerModel[] = [];

  constructor(
    private readonly cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    const arrTimes = this.populateTime(this.minTime, this.maxTime, 30);
    const idxTime = arrTimes.findIndex((t) => t === this.initValue);
    this.dataPickerModel = [
      {
        List: arrTimes.map((value) => ({ Id: value, Value: value })),
        CurrentIndex: idxTime >= 0 ? idxTime : null,
      }
    ];
    this.timeValue = this.value;
  }

  public toggleTimepicker(): void {
    this.showSwipeUp = !this.showSwipeUp;
    this.cdr.detectChanges();
  }

  public updateTime(event: DataPickerChangedEvent): void {
    this.timeValue = event?.option?.Value;
    this.dataPickerModel[0].CurrentIndex = event?.selectedIndex;
  }

  public applyTime(): void {
    if (!this.timeValue && isNullOrUndefined(this.dataPickerModel[0].CurrentIndex)) {
      this.toggleTimepicker();
    } else if (!this.timeValue) {
      this.timeValue = this.initValue;
    }
    this.value = this.timeValue;
    this.toggleTimepicker();
    this.timeSelection.emit(this.timeValue);
  }

  private populateTime(from: number, to: number, interval: number): string[] {
    const arr: string[] = [];
    for (let i = from; i <= to; i++) {
      for (let j = 0; j < 60; j += interval) {
        if (j === interval && i === to) {
          break;
        }
        const hour = i;
        const minutes = j;
        let text = hour < 10 ? `0${hour}` : `${hour}`;
        text += ':';
        text += minutes < 10 ? `0${minutes}` : `${minutes}`;
        arr.push(text);
      }
    }
    return arr;
  }

}
